module.exports = __webpack_public_path__ + "741da9504b844f2b57ef99a53c0a9e3a.svg";